module.exports = __webpack_public_path__ + "img/liyou2.286bd4ed.png";